import type { Timestamp } from "firebase/firestore";
import type { TKey } from "./translations/translationKeys";

export type BusinessEmailType = "feed" | "feed_comment" | "feed_comment_reply";

export type BusinessEmailItemData = {
  uid: string;
  ts: Timestamp;
  type: BusinessEmailType;
  author: {
    uid: string;
    name: string;
  };
  textSID: TKey;
  textData: Record<string, string | number>;

  parent?: BusinessEmailItemData | null;
};

export type BusinessEmailEventTemplateData = {
  createdAt: Timestamp; // used to query out events

  business: {
    uid: string;
    name: string;
  };

  item: BusinessEmailItemData;
};

export type EmailEventTemplateData = {
  createdAt: Timestamp; // used to query out events
  createdAtMs?: number; // used in email
  refUid: string;
  planira: {
    uid: string;
    name: string;
  };
  module: { uid: string; typeEnum: string; name: string };
  author: {
    uid: string;
    name: string;
  };
  typeEnum: string;
  text?: string;
  textSID: TKey;
  textData: Record<string, string | number>;
};

export type EmailReminderDbData = {
  uid?: string; // once saved

  createdAt: Omit<Timestamp, "toJSON">; // used to query out events
  isProcessed: boolean; //
  planUid: string;

  // Date when it happens, or null if it needs to be wiped
  eventDate: Timestamp | null;

  // To be able to lookup info
  moduleUid: string;

  // Set info even though it can be outdated
  planName: string;
};

export enum PlaniraLogType {
  TappedOnTip = "tapped_tip",
  CardIsDone = "card_done",
  CardArchived = "card_archived",
  CardCreated = "card_created",
  CardComment = "card_comment",
}

export type PlaniraLogData = {
  createdAt: Timestamp; // used to query out events
  refPlanUid: string;
  refUserUid: string;
  type: PlaniraLogType;
  text?: string;
};
